import ErrorBoundary from "@components/error-boundary";
import { ClientSideSuspense } from "@liveblocks/react/suspense";
import type { ReactNode } from "react";

export const Suspense = ({
  children,
  feature,
  skipFallback,
  fallback = <></>,
  loader = <></>,
}: {
  children: ReactNode;
  feature: string;
  fallback?: ReactNode;
  loader?: ReactNode;
  skipFallback?: boolean;
}) => {
  return (
    <ErrorBoundary
      fallback={fallback}
      feature={feature}
      skipFallback={skipFallback}
    >
      <ClientSideSuspense fallback={loader}>{children}</ClientSideSuspense>
    </ErrorBoundary>
  );
};
